export function convertToGB(byte?: number) {
  // if (!byte) return 0;
  // return Math.floor(byte / 1024 ** 2) / 2; // 바이트를 GB로 변환

  const GIBI_DIVISOR = 1024 ** 3; // 1 GiB = 1024^3 bytes bytes를 GiB로 변환
  return parseFloat((byte! / GIBI_DIVISOR).toFixed(2)); // 숫자 형태로 변환
}
